import { jsx, jsxs } from "react/jsx-runtime";
import { Grid } from "@elliemae/ds-grid";
import { isEmpty } from "lodash";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  evaluateRuleById,
  isShallowEqual,
  zeroPadCensusTract
} from "../utils/utils";
const PropertyReadOnly = ({
  schemaForm,
  rules,
  preview,
  visible,
  visibleCheck
}) => {
  const [isVisible, setIsVisible] = useState(visible);
  const ratesSelector = preview ? () => {
  } : ({ EPPS }) => EPPS?.loanPrograms?.geoCodes;
  const lookupsSelector = preview ? () => {
  } : ({ eppsData: { lookups = {} } }) => lookups?.data?.geocodes;
  const ratesGeoCodes = useSelector(ratesSelector, isShallowEqual);
  const lookupGeocodes = useSelector(lookupsSelector, isShallowEqual);
  let geoCodes;
  if (ratesGeoCodes) {
    geoCodes = ratesGeoCodes;
  } else if (!isEmpty(lookupGeocodes)) {
    geoCodes = lookupGeocodes;
  } else {
    geoCodes = {
      msa: schemaForm.getValues("property.msa"),
      censusTract: schemaForm.getValues("property.censusTract"),
      countyCode: schemaForm.getValues("property.countyCode"),
      stateCode: schemaForm.getValues("property.stateCode")
    };
  }
  useEffect(() => {
    setIsVisible(visible);
  }, [visible]);
  useEffect(() => {
    const updateVisibility = () => {
      if (visibleCheck?.handler) {
        setIsVisible(
          evaluateRuleById(
            visibleCheck.handler,
            schemaForm.getValues(),
            rules,
            preview
          ) ? !visible : visible
        );
      }
    };
    const subscription = schemaForm.watch(() => {
      updateVisibility();
    });
    updateVisibility();
    return () => subscription.unsubscribe();
  }, [schemaForm]);
  return /* @__PURE__ */ jsxs(
    Grid,
    {
      span: 12,
      gutter: "xxs",
      style: { display: "flex", flexWrap: "nowrap" },
      children: [
        /* @__PURE__ */ jsxs(Grid, { style: { width: "25%" }, children: [
          /* @__PURE__ */ jsx("span", { style: { display: "block", marginBottom: "10px" }, children: "MSA" }),
          /* @__PURE__ */ jsx("b", { children: geoCodes.msa })
        ] }),
        /* @__PURE__ */ jsxs(Grid, { style: { width: "25%" }, children: [
          /* @__PURE__ */ jsx("span", { style: { display: "block", marginBottom: "10px" }, children: "Census Tract" }),
          /* @__PURE__ */ jsx("b", { children: zeroPadCensusTract(
            geoCodes.censusTract ? String(geoCodes.censusTract) : ""
          ) })
        ] }),
        /* @__PURE__ */ jsxs(Grid, { style: { width: "25%" }, children: [
          /* @__PURE__ */ jsx("span", { style: { display: "block", marginBottom: "10px" }, children: "County Code" }),
          /* @__PURE__ */ jsx("b", { children: geoCodes.countyCode })
        ] }),
        /* @__PURE__ */ jsxs(Grid, { style: { width: "25%" }, children: [
          /* @__PURE__ */ jsx("span", { style: { display: "block", marginBottom: "10px" }, children: "State Code" }),
          /* @__PURE__ */ jsx("b", { children: geoCodes.stateCode })
        ] })
      ]
    }
  );
};
export {
  PropertyReadOnly
};
